import { createElement, useEffect } from 'react';
import { withPreAuthEnglish } from '../i18n/PreAuthEnglish';
import { lazyPreloadable as lazy } from '../utils/ui/lazyPreloadable';

// Pre-sign-in pages: always English (RD-I18N-006). Each stays in its own lazy
// chunk; the wrapper is created once per chunk load (stable reference).
// RD-LUI-016: the lazies are preloadable so an in-app jump back to Login renders
// with no Suspense blank / boot splash; cold loads still suspend as before.
export const Login = lazy(() => import('./Login').then((m) => ({ default: withPreAuthEnglish(m.default) })));

function idle(fn) {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(fn);
    return () => window.cancelIdleCallback?.(id);
  }
  const id = setTimeout(fn, 200);
  return () => clearTimeout(id);
}

// While reset-password / accept-invite is mounted, warm Login at idle (not /unsubscribe).
function withLoginWarm(Page) {
  function WithLoginWarm(props) {
    useEffect(() => idle(() => Login.preload()), []);
    return createElement(Page, props);
  }
  return WithLoginWarm;
}
const wrap = (m) => ({ default: withLoginWarm(withPreAuthEnglish(m.default)) });

export const ResetPassword = lazy(() => import('./ResetPassword').then(wrap));
export const AcceptInvite = lazy(() => import('./AcceptInvite').then(wrap));
export const Unsubscribe = lazy(() => import('./Unsubscribe').then((m) => ({ default: withPreAuthEnglish(m.default) })));
export const BillingDone = lazy(() => import('./BillingDone').then((m) => ({ default: withPreAuthEnglish(m.default) })));
